<div class="container-fluid">
    <div class="row">
      <div style="margin-top:1%; margin-bottom:-50px; margin-left:10px">
        <h6>
          <span style="padding-right:5px"></span>
         <!-- <i class="fa fa-pencil-square-o"></i>
         <b>Motivation </b>-->
        </h6>
      </div>
    </div>
    <hr>
    <form [formGroup]="form">
    <div class="col-md-12 p-0">
        <div class="col-sm-12 p-0">
            <!-- <label for="description"> Please motivate the need for the particular service(s)</label> -->
            <textarea [(ngModel)]="model.application.motivation_detail" formControlName="motivation" (click)="changes()"  style="min-width: 100%">
              </textarea>  
        </div>
    </div>
    </form>
  </div>
  
  <ngx-loading [show]="pageload"></ngx-loading>
